import { render, staticRenderFns } from "./AssinarRequisicao.vue?vue&type=template&id=2b62478c&"
import script from "./AssinarRequisicao.vue?vue&type=script&lang=js&"
export * from "./AssinarRequisicao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports